import supervisorConstants from '../constants';
import authConstants from 'areas/auth/constants';

const initialState = {
    requestingDivisions: false,
    requestingDivisionData: false,
    locationDialogOpen: false
};

const markComplete = (state, competence) => {
    const match = state.scheduledComps.filter(sc => sc.scheduledCompetenceID === competence.scheduledCompetenceID);

    if (!match || match.length === 0) return state;

    const rest = state.scheduledComps.filter(sc => sc.scheduledCompetenceID !== competence.scheduledCompetenceID);
    const singleMatch = match[0];

    return {
        ...state,
        scheduledComps: [].concat(rest, {
            ...singleMatch,
            award: {
                date: new Date()
            }
        })
    }
};

export function supervisor(state = initialState, action) {
    switch (action.type) {
        case authConstants.SIGN_OUT_SUCCESS:
            return initialState;

        case supervisorConstants.OPEN_LOCATION_DIALOG:
            return {
                ...state,
                locationDialogOpen: true,
                isApplying: false
            };
        case supervisorConstants.CLOSE_LOCATION_DIALOG:
            return {
                ...state,
                locationDialogOpen: false,
                isApplying: true
            };
        case supervisorConstants.SUPERVISOR_DATA_SUCCESS:
            return {
                ...state,
                ...action.divisions
            };
        case supervisorConstants.DIVISION_DATA_SUCCESS:
            return {
                ...state,
                ...action.data
            };
        case supervisorConstants.LOCATION_COMPETENCE_DATA_SUCCESS:
            return {
                ...state,
                ...action.competenceData
            };
        case supervisorConstants.MARK_PENDING_COMPETENCE_AS_COMPLETE:
            return markComplete(state, action.competence);
        default:
            return state;
    }
}